module.exports = __webpack_public_path__ + "static/media/edit-disabled.5cc3065a.svg";